export const galleryImages = [
  {
    url: `${process.env.PUBLIC_URL}/0.jpg`,
    alt: "",
  },
  {
    url: `${process.env.PUBLIC_URL}/1.jpg`,
    alt: "",
  },
  {
    url: `${process.env.PUBLIC_URL}/2.jpg`,
    alt: "",
  },
  {
    url: `${process.env.PUBLIC_URL}/3.jpg`,
    alt: "",
  },
  {
    url: `${process.env.PUBLIC_URL}/5.jpg`,
    alt: "",
  },
  {
    url: `${process.env.PUBLIC_URL}/6.png`,
    alt: "",
  },
  {
    url: `${process.env.PUBLIC_URL}/7.png`,
    alt: "",
  },
];
